const {
  initializeAndTrackGoogleAnalytics,
  initializeAndTrackGoogleTagManager,
  initializeAndTrackFacebookPixel,
  initializeAndTrackTikTokPixel,
  initializeAndTrackHotjar,
  initializeChatwoot,
  initializeLinkedin,
  initializeAndTrackLuckyOrange,
  initializeAndTrackHubspot,
} = require("./services")

const { isEnvironmentValid } = require("./helper")

let isInitialized = false

const runInitTrack = async (location, options, tagManagerInit) => {
  initializeAndTrackGoogleTagManager(options.googleTagManager, location)
  initializeAndTrackGoogleAnalytics(
    options.googleAnalytics,
    location,
    tagManagerInit
  )
  initializeAndTrackFacebookPixel(options.facebookPixel)
  initializeAndTrackHubspot(options.hubspot, location)
  initializeAndTrackTikTokPixel(options.tikTokPixel)
  initializeAndTrackLuckyOrange(options.luckyOrange)
  initializeAndTrackHotjar(options.hotjar)
  initializeChatwoot(options.chatwoot)
  initializeLinkedin(options.linkedin)
  isInitialized = true
}

exports.initializeAndTrack = (location, initialize = false, tagManagerInit) => {
  const options = window.gatsbyPluginGDPRCookiesOptions
  if (
    options &&
    options.waitForInitalization &&
    !initialize &&
    !isInitialized
  ) {
    return
  }

  if (!isEnvironmentValid(options.environments)) {
    return
  }
  if (location === undefined || location === null) {
    console.error(
      "Please provide a reach router location to the initializeAndTrack function."
    )
    return
  }

  if (isInitialized) {
    runInitTrack(location, options, tagManagerInit)
  } else if ("requestIdleCallback" in window) {
    requestIdleCallback(
      () => {
        setTimeout(() => {
          runInitTrack(location, options, tagManagerInit)
        }, 300)
      },
      { timeout: 2000 }
    )
  } else {
    // Fallback for browsers that don't support requestIdleCallback
    setTimeout(() => {
      runInitTrack(location, options, tagManagerInit)
    }, 500)
  }
}
